import { Badge } from "@qw/ui";
import type { FC } from "react";
import type { ProductHistoricalInsights } from "../historical-insights.types";

interface Props {
  classContext: ProductHistoricalInsights["classContext"];
}

export const InsightsClassContextSection: FC<Props> = ({ classContext }) => {
  const hasData =
    classContext.marketDifficulty != null ||
    classContext.preferredCarriers.length > 0 ||
    classContext.keyExposures.length > 0 ||
    classContext.commonExclusions.length > 0;

  if (!hasData) {
    return null;
  }

  return (
    <div className="space-y-3">
      <h3 className="text-sm font-semibold">Class Context</h3>

      <div className="flex flex-wrap gap-2">
        {classContext.marketDifficulty && <Badge variant="secondary">{classContext.marketDifficulty}</Badge>}
        {classContext.isPreferredForClass && <Badge variant="green">Preferred Carrier</Badge>}
      </div>

      {classContext.preferredCarriers.length > 0 && (
        <div>
          <h4 className="text-xs font-medium text-muted-foreground mb-1">Preferred Carriers</h4>
          <div className="flex flex-wrap gap-1">
            {classContext.preferredCarriers.map((carrier) => (
              <Badge key={carrier} variant="outline">
                {carrier}
              </Badge>
            ))}
          </div>
        </div>
      )}

      {classContext.keyExposures.length > 0 && (
        <div>
          <h4 className="text-xs font-medium text-muted-foreground mb-1">Key Exposures</h4>
          <ul className="list-disc list-inside text-xs space-y-0.5">
            {classContext.keyExposures.map((exp, i) => (
              <li key={i}>{exp}</li>
            ))}
          </ul>
        </div>
      )}

      {classContext.commonExclusions.length > 0 && (
        <div>
          <h4 className="text-xs font-medium text-muted-foreground mb-1">Common Exclusions</h4>
          <ul className="list-disc list-inside text-xs space-y-0.5">
            {classContext.commonExclusions.map((exc, i) => (
              <li key={i}>{exc}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
